// export DsfPlatformPersonnelCard from "./personnelCard.vue";
export const DsfPlatformPersonnelCard = dsf.defineAsyncComponent("DsfPlatformPersonnelCard", () => import(/*webpackChunkName:"platform_pc_other"*/ "./personnelCard.vue"));
